<script lang="ts" setup>
import { ref } from "vue";
import PoolIcon from "@/features/pools/PoolIcon.vue";
import { PoolDetails } from "@/models/pool-details.model.ts";
import BlePopoverWrapper from "@/features/ble/scan/BlePopoverWrapper.vue";

const opened = ref(false);

const { pool } = defineProps<{
  pool: PoolDetails & { deviceId: string; localNickname: string };
}>();
</script>

<template>
  <BlePopoverWrapper :pool="pool">
    <div class="card p-4 flex items-center" @click="opened = true">
      <div class="flex-grow-0 flex-shrink-0" style="width: 32px; height: 32px">
        <PoolIcon :is-ble="true" />
      </div>

      <div class="flex-shrink ml-3">
        <h1 class="text-md font-medium mb-0.5 flex">
          {{ pool.localNickname ?? pool.poolNickname }}
        </h1>
      </div>
    </div>
  </BlePopoverWrapper>
</template>
